import {
    Component,
    ViewEncapsulation,
    Input,
    Output,
    EventEmitter,
    ViewChild,
    OnInit
} from '@angular/core';
import {Router, NavigationStart, RouterEvent, Event} from "@angular/router";
import {filter} from 'rxjs/operators';
import { MobileLinksDTO } from '@signature-it/ngx-generic/models';
import { LanguageService, EventBusService } from '@signature-it/ngx-generic/services';
import {EventData, EventName} from '@signature-it/ngx-generic/classes';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector: 'main-header-navbar-mobile-side',
    templateUrl: './navbar-mobile-side.html',
    styleUrls: ['./navbar-mobile-side.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MainHeaderNavbarMobileSideComponentGeneric implements OnInit {
    public readonly ATTR_SIDE = "side";

    @ViewChild('sidenav', {static: true}) sidenav: any;
    @Input() data: MobileLinksDTO[];
    @Output() toggle = new EventEmitter();

    catalogConf = {
        id: "_burger",
        standAlone: true
    };
    showLangs = false;
    cmsFooterTitle = 'ngx-burger-footer';
    showSearch = false;

    constructor(protected langSvc: LanguageService,
                protected eventBusService: EventBusService,
                protected router: Router) {

        this.router.events.pipe(
            filter((e: Event | RouterEvent): e is RouterEvent => e instanceof NavigationStart)
        ).pipe(takeUntilDestroyed()).subscribe((e: NavigationStart) => {
            this.eventBusService.emit(new EventData(EventName.MENU_NAVIGATE, true));
        });
    }

    ngOnInit() {
        if (this.langSvc.getStoredLangList() && this.langSvc.getStoredLangList().length > 1) {
            this.showLangs = true;
        }
    }

    sidebarToggle() {
        this.toggle.next(true);
    }

    isExternalLink(link) {
        return /^https?:\/\//i.test(link);
    }

    showSearchArea() {
        this.showSearch = true;
        this.sidebarToggle();
    }

    hideSearch() {
        this.showSearch = false;
    }
}
